const itemsTypes = {
  FETCH_ITEMS: "FETCH_ITEMS",
  RESET_ITEMS: "RESET_ITEMS",
  FETCH_ADMIN_ITEMS: "FETCH_ADMIN_ITEMS",
  RESET_ADMIN_ITEMS: "RESET_ADMIN_ITEMS",
};

export default itemsTypes;
